import Vue from "vue";
import VueRouter from "vue-router";

import Login from './Login';
import ForgotPassword from './ForgotPassword';
import ChangePassword from './ChangePassword';

Vue.use(VueRouter);

export default new VueRouter({
    routes: [
        {
            path: '/platform/:platform/login',
            name: 'Platform-Login',
            component: Login
        },
        {
            path: '/admin/login',
            name: 'Admin-Login',
            component: Login
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/forgot-password',
            name: 'ForgotPassword',
            component: ForgotPassword
        },
        {
            path: '/reset-password/:hash?',
            name: 'ChangePassword',
            component: ChangePassword,
            props: (route) => ({hashFromUrl: route.params.hash}),
        },
        {
            path: '*',
            redirect: '/login'
        },
    ],
    mode: 'history',
});
